module.exports = __webpack_public_path__ + "img/sieckFinesseRelease5.892bbc6c.png";